
const predictiveSearchSection = document.querySelector('.predictive-search-results');
var requestResponse;

$(document).ready(function(){
  
$(".site-header__search-input").on("keyup", function() {
 var loader=`<img src="https://cdn.shopify.com/s/files/1/0258/1394/2371/files/Preloader_1.gif?v=1653767669"/>`; 
   $(".loader").empty();
  $(".loader").append(loader);
  
  $('.results_wrapper').css("visibility","hidden");
  $('.collection_menu').hide();
$('.results_wrapper_outer').addClass("rwo_full");  
  $(".nrf").empty();
  setTimeout(function () {
    $('.collection_menu').hide("slow");
   $(".loader").empty();
    $(".nrf").show();
     $('.results_wrapper').css("visibility","visible");
 }, 2000);
  
var search_q = $(this).val();
  
if(search_q!="")  {
  
var resulte=true;
fetch(window.Shopify.routes.root + "search/suggest.json?q="+search_q+"&resources[type]=product,article,collection&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,tag,author,vendor")
  .then((response) => response.json())
  .then((suggestions) => {
  const productSuggestions = suggestions.resources.results;
 var product = productSuggestions.products.length;
  $("#products").empty();
  $("#collections").empty();
//   $("#pages").empty();
  $("#articles").empty();


  
 if(productSuggestions.products.length > 0 
    || productSuggestions.collections.length > 0 
    || productSuggestions.articles.length > 0
   ){
   
   $.each(productSuggestions, function(key,productSuggestionsarrays){
      
      if(key == "products"){
         $.each(productSuggestionsarrays, function(i,productSuggestionsarray){
        
           if(i == 0 ){
           var products_title =`<div id="products_title_label">products</div>`;
           }else{
             products_title="";
           }
           if(productSuggestionsarray.tags.includes('hide') && i == 0){
            var products_res=`${products_title}`;
              $("#products").append(products_res);
           }else if(productSuggestionsarray.tags.includes('hide')){

           }else{
              var products_res=`
              ${products_title}
              <a href="${productSuggestionsarray.url }" id="search_url">
              <div class="search_res_products">
                  <div class="image_search_product">
                      <img src="${ productSuggestionsarray.featured_image.url }" alt="${productSuggestionsarray.title}"/>
                  </div>
                  <div class="title_search_product">
                      <p id="title_search_product_text">${productSuggestionsarray.title}</p>
                    </div>
                  </div> 
                </a>
              `;
              $("#products").append(products_res);
           }
         
           
        });
      }
  
      
    
      if(key == "collections"){
         $.each(productSuggestionsarrays, function(i,productSuggestionsarray){
           console.log(productSuggestionsarray.handle)
   
         if(i == 0 ){
           var collections_title =`<div id="collections_title_label">collections</div>`;
         }else{
           collections_title="";
         }
         if(productSuggestionsarray.featured_image.url){
           var collections_image =`<img src="${ productSuggestionsarray.featured_image.url }" alt="${productSuggestionsarray.title}"/>`;
         }else{
         
           collections_image=`<img src="https://cdn.shopify.com/s/files/1/0258/1394/2371/files/No-Image.jpg?v=1653685495" alt="${productSuggestionsarray.title}"/>`;
         } 
         var collections_res=`
            ${collections_title}
         <a href="${productSuggestionsarray.url }" id="search_url">
           <div class="search_res_products">
              <div class="image_search_product">
               
              </div>
              <div class="title_search_product">
                   <p id="title_search_product_text">${productSuggestionsarray.title}</p>
                </div>
              </div> 
            </a>
           `;
           $("#collections").append(collections_res);
         // }
        });
      }

      
   
//        if(key == "pages"){
//          $.each(productSuggestionsarrays, function(i,productSuggestionsarray){
   
//          if(i == 0 ){
//            var pages_title =`<div id="pages_title_label">pages</div>`;
//          }else{
//            pages_title="";
//          }
         
//          var pages_res=`
//             ${pages_title}
//            <a href="${productSuggestionsarray.url }" id="search_url">
//            <div class="search_res_products">
//               <div class="image_search_product"> 
//                  <img src="https://cdn.shopify.com/s/files/1/0258/1394/2371/files/No-Image.jpg?v=1653685495" alt="${productSuggestionsarray.title}"/>
//               </div>
//               <div class="title_search_product">
//                    <p id="title_search_product_text">${productSuggestionsarray.title}</p>
//                 </div>
//               </div>
//            </a>
//            `;
//            $("#pages").append(pages_res);
//         });
//       }
     
         
    
    if(key == "articles"){
         $.each(productSuggestionsarrays, function(i,productSuggestionsarray){
   
         if(i == 0 ){
           var articles_title =`<div id="pages_title_label">Articles</div>`;
         }else{
           articles_title="";
         }
         if(productSuggestionsarray.featured_image.url){
           var articles_image =`<img src="${ productSuggestionsarray.featured_image.url }" alt="${productSuggestionsarray.title}"/>`;
         }else{
         
           articles_image=`<img src="https://cdn.shopify.com/s/files/1/0258/1394/2371/files/No-Image.jpg?v=1653685495" alt="${productSuggestionsarray.title}"/>`;
         }
         var articles_res=`
            ${articles_title}
           <a href="${productSuggestionsarray.url }" id="search_url">
           <div class="search_res_products">
              <div class="image_search_product"> 
                ${articles_image}
              </div>
              <div class="title_search_product">
                   <p id="title_search_product_text">${productSuggestionsarray.title}</p>              
                </div>
             
              </div>
           </a>
           `;
           $("#articles").append(articles_res);
        });
      }

       
    });
   
//     $('.collection_menu').removeClass("hide_cat");
  console.log("sss"+ productSuggestions.products.length) 
     //to check result empty
     let productsCount = productSuggestions.products.length;
     for(let i=0; i< productSuggestions.products; i++){
      if(productsCount.tags.includes('hide')){
        productsCount = productsCount - 1;
      }
     }
  if(productsCount<= 0){
    $('#products').hide();
//     $('.collection_menu').css("display","none !important");
    console.log("proedd")
  }else if (productSuggestions.collections.length <=  0 ){
    $('#collections').hide();
//      $('.collection_menu').css("display","none !important");
      console.log("coll")
  }
   else if (productSuggestions.articles.length <=  0){
    
      $('#articles').hide();
//       $('.collection_menu').css("display","none !important");
      console.log("art")
  }
   
 }
  else{
 
  $("#products").empty();
  $("#collections").empty();
//   $("#pages").empty();
  $("#articles").empty();
  $(".nrf").empty();
  $(".loader").empty();
//    $('.collection_menu').addClass("hide_cat");

  $(".nrf").append("<p>Hit search for all results!</p>");

 
    
  }
   
}
); 
    
}
else{
 $(".nrf").empty();
  $("#products").empty();
  $("#collections").empty();
//   $("#pages").empty();
  $("#articles").empty();
  
  $(".loader").empty();
//   $('.collection_menu').addClass("hide_cat");
  $(".nrf").append("<p>Hit search for all results!</p>");

   
 }
  
 });
});